<template>
    <div class="noData">
        <span v-if="!$root.axiosNumberArr.length">暂无数据</span>
    </div>
</template>

<script>
export default {
    data(){
        return{
        }
    }
}
</script>

<style lang="stylus" scoped>
    .noData
        width 100%
        min-height  200px
        display flex
        justify-content center
        align-items center
        span
            font-size  24px
            color #8F8F8F
</style>



// WEBPACK FOOTER //
// src/components/tools/noData.vue